import {createContext, useEffect} from 'react'

import React from 'react'
// import combineReducer from '../../utils/combineReducers'

import LabelEditorReducer from '../../state/barcode/label-editor/reducer'
import {
  addItem,
  removeItem,
  updateItem,
  deselectAllItem,
  selectItem,
  setZoom,
  initialize,
} from '../../state/barcode/label-editor/actions'

const BarcodeLabelEditorContext = createContext()

const BarcodeLabelEditorContextProvider = ({children, initialValue}) => {
  // [A]
  const [state, dispatch] = React.useReducer(LabelEditorReducer, {
    labelItems: [],
    zoom: 2,
  })

  const _addItem = React.useCallback(data => addItem(data, dispatch), [dispatch])
  const _removeItem = React.useCallback(data => removeItem(data, dispatch), [dispatch])
  const _updateItem = React.useCallback(data => updateItem(data, dispatch), [dispatch])
  const _deselectAllItem = React.useCallback(() => deselectAllItem(dispatch), [])
  const _selectItem = React.useCallback(data => selectItem(data, dispatch), [])
  const _setZoom = React.useCallback(data => setZoom(data, dispatch), [])
  const _initialize = React.useCallback(data => initialize(data, dispatch), [])

  useEffect(() => {
    if (initialValue !== undefined) {
      _initialize({items: [...initialValue.labelItems]}, dispatch)
    }
  }, [initialValue, _initialize])

  const value = {
    addItem: _addItem,
    updateItem: _updateItem,
    removeItem: _removeItem,
    deselectAllItem: _deselectAllItem,
    selectItem: _selectItem,
    setZoom: _setZoom,
    dispatch,
    initialize: _initialize,
    state,
  }

  // [B]
  return (
    <BarcodeLabelEditorContext.Provider value={value}>
      {children}
    </BarcodeLabelEditorContext.Provider>
  )
}

const BarcodeLabelEditorContextConsumer = BarcodeLabelEditorContext.Consumer

export {
  BarcodeLabelEditorContext,
  BarcodeLabelEditorContextProvider,
  BarcodeLabelEditorContextConsumer,
}
